import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { getSeniorConfig } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-data/projects/senior'
import { getTruthAndTreasonConfig } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-data/projects/truth-and-treason'
import { GiveawayConfig } from '../types'
import {
  getLastRodeoConfig,
  getKingOfKingsConfig,
  getSketchConfig,
  getYoungWashingtonConfig,
  getDavidConfig,
  getIwasConfig, // TODO: Add Solo Mio config back in when it's ready
  // getSoloMioConfig,
} from './projects'

const GIVEAWAY_CONFIGS: Record<string, (t: TranslateFunction) => GiveawayConfig> = {
  [slugs.kingOfKings]: getKingOfKingsConfig,
  [slugs.theLastRodeo]: getLastRodeoConfig,
  [slugs.sketch]: getSketchConfig,
  [slugs.youngWashington]: getYoungWashingtonConfig,
  [slugs.senior]: getSeniorConfig,
  [slugs.truthAndTreason]: getTruthAndTreasonConfig,
  [slugs.david]: getDavidConfig,
  [slugs.iWasAStranger]: getIwasConfig,
  // [slugs.soloMio]: getSoloMioConfig,
}

export const VACATION_SLUGS = new Set([slugs.braveTheDark, slugs.ruleBreakers])

export const getGiveawayConfig = (theatricalSlug: string, t: TranslateFunction): GiveawayConfig | null => {
  const configFactory = GIVEAWAY_CONFIGS[theatricalSlug]
  return configFactory ? configFactory(t) : null
}

export const isVacationSlug = (theatricalSlug: string): boolean => {
  return VACATION_SLUGS.has(theatricalSlug)
}
